import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
// import { ApolloLink } from 'apollo-link'

export type TalkApolloClient = ApolloClient<NormalizedCacheObject>

export const talkApolloClient: TalkApolloClient = new ApolloClient({
	link: ApolloLink.from([
		onError(({ graphQLErrors, networkError }) => {
			if (graphQLErrors)
				graphQLErrors.forEach(({ message, locations, path }) =>
					console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
				)
			if (networkError) console.log(`[Network error]: ${networkError}`)
		}),
		new HttpLink({
			uri: 'https://talk.schedio.app',
			credentials: 'same-origin'
		})
	]),
	cache: new InMemoryCache()
})
